import '@d3fc/d3fc-element';

import { line } from 'utils/components/TimeSeriesChart/line';
import { area } from 'utils/components/TimeSeriesChart/area';
import { SignalChartTimeSeriesItem } from 'widgets/signalTiles/signalTile/components/chart/signalTileData';

const belowLine = line<SignalChartTimeSeriesItem>((d) => d.below, 'below-line');

const belowArea = (lowerBoundary: number) =>
    area<SignalChartTimeSeriesItem>(
        (d) => d.below,
        'below-area',
        undefined,
        () => lowerBoundary
    );

export const belowSeries = (lowerBoundary: number) => [
    belowLine,
    belowArea(lowerBoundary),
];
